<div
  *ngIf="touched"
>
  <span
    *ngIf="isErroneous"
    class="errorLabelStyle"
  >
    <b>{{fieldLabelName}}</b> {{requiredAction}}
  </span>
</div>
